import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        const r = await api.post("/auth/refresh");
        setUser(r.data);
      } catch {
        setUser(false);
      }
    });
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  const canEdit = user && user.role !== "observador";

  return <AuthCtx.Provider value={{ user, login, logout, canEdit }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
